<div class="header">
	<h2>Instellingen</h2>
	<app-button class="right" (clickit)="openInstellingToevoegen()" icon="toevoegen">Instelling toevoegen</app-button>
	<app-icon name="export" color="primary-1" hoverColor="primary-1" size="large" (click)="export()"></app-icon>
</div>
<div class="search-header">
	<app-instant-search-box (fire)="searchInput$.next($event)" placeholder="Instelling, bestuur of vestiging zoeken"></app-instant-search-box>
	<div class="label-filter">
		<span class="label">Label</span>
		<app-single-select-dropdown
			[opties]="labels"
			[selectedOptie]="getSelected(labels, selectedLabel())"
			(onOptieClicked)="selectedLabel.set($event)"
		>
		</app-single-select-dropdown>
	</div>
</div>
@if (instellingen$ | async; as instellingen) {
	<app-instellingen-list
		[instellingen]="instellingen"
		[warningIconEnabled]="true"
		[statusEnabled]="true"
		[licenties]="[LicentieRol.SCHOOLBREEDTEAM, LicentieRol.SECTIE, LicentieRol.DOCENTMENTOR, LicentieRol.AANWEZIGHEID]"
		[totaalEnabled]="true"
		(instellingClick)="gotoInstelling($event)"
		(instellingCtrlClick)="gotoInstellingOnNewTab($event)"
	>
	</app-instellingen-list>
}
